module.exports = __webpack_public_path__ + "img/7.3bddfc4e.png";